interface ScopeProps {
  name: string;
  unique_name: string;
}

export class Scope implements ScopeProps {
  name: string;
  unique_name: string;

  constructor(data: ScopeProps) {
    this.name = data.name;
    this.unique_name = data.unique_name;
  }
}
